<template>
    <form-row title="Seller 1">
        <div class="flex-1 -mt-2">
            <div class="flex flex-col sm:flex-row">
                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[seller_1][name]"
                        v-model="contact_name"
                        label="Name"
                        placeholder="Name"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[seller_1][email]"
                        v-model="contact_email"
                        label="Email"
                        placeholder="Email"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[seller_1][phone]"
                        v-model="contact_phone"
                        label="Phone"
                        placeholder="Phone"
                        :read_only="read_only"
                    />
                </div>
            </div>

            <div>
                <div class="mt-4">
                    <input-checkbox
                        name="seller_1_address_same_as_property"
                        label="Same Address as Property"
                        v-model="seller_1_address_same_as_property"
                        :read_only="read_only"
                    />
                </div>

                <div v-if="! seller_1_address_same_as_property">
                    <div class="mt-3">
                        <input-text
                            label="Address"
                            name="contacts[seller_1][address_1]"
                            :value="contact.address_1"
                            placeholder="Address"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="mt-3">
                        <input-text
                            name="contacts[seller_1][address_2]"
                            :value="contact.address_2"
                            placeholder="Address 2"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="flex flex-col sm:flex-row sm:mt-3">
                        <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                            <input-text
                                name="contacts[seller_1][city]"
                                :value="contact.city"
                                placeholder="City"
                                :read_only="read_only"
                            />
                        </div>

                        <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                            <input-select-states
                                name="contacts[seller_1][state]"
                                no_selection="Select State"
                                :value="contact.state"
                                :read_only="read_only"
                            />
                        </div>

                        <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                            <input-text
                                name="contacts[seller_1][zip]"
                                :value="contact.zip"
                                placeholder="Zip"
                                :read_only="read_only"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        contact: { default: () => ({}) },
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            contact_name: this.contact.name,
            contact_email: this.contact.email,
            contact_phone: this.contact.phone,
            seller_1_address_same_as_property: this.deal.seller_1_address_same_as_property,
        }
    },

    computed: {
        our_sale() {
            return store.state.our_sale;
        },
    },

    watch: {
        our_sale(val) {
            if (val) {
                if (! this.contact_name) {
                    this.contact_name = this.property.client.name;
                }

                if (! this.contact_email) {
                    this.contact_email = this.property.client.email;
                }
            }
        },
    },
}
</script>
